import { render, staticRenderFns } from "./LegalNoticeDialog.vue?vue&type=template&id=62d7a885"
import script from "./LegalNoticeDialog.vue?vue&type=script&lang=js"
export * from "./LegalNoticeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports